import "@arco-design/web-react/es/Popconfirm/style";
import _Popconfirm from "@arco-design/web-react/es/Popconfirm";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import React from 'react';
export function ButtonOperate({
  onOk,
  status,
  text,
  disabled,
  loading = false
}) {
  return /*#__PURE__*/React.createElement(_Popconfirm, {
    title: "\u786E\u5B9A\u64CD\u4F5C?",
    onOk: onOk
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "secondary",
    status: status,
    size: "small",
    disabled: disabled,
    loading: loading
  }, text));
}